import { registerFunctionalComponent } from 'js/lib/components/component'
import { useFormInput } from 'js/lib/form'

const PLACEHOLDER_CLASS = 'c-select--with-placeholder'

registerFunctionalComponent('.js-c-form-select', 'Select', Select)

function Select(component) {
  const { onDependentChange } = useFormInput(component.element)

  // on load remove the placeholder class
  if (component.element.value !== '') {
    component.element.classList.remove(PLACEHOLDER_CLASS)
  }

  component.useHandler(() => {
    component.element.addEventListener('change', handleOffPlaceholder)
    return () => component.element.removeEventListener('change', handleOffPlaceholder)
  })

  onDependentChange(dependency => handleDependentChange(component.element, dependency))

  function handleOffPlaceholder() {
    component.element.classList.remove(PLACEHOLDER_CLASS)
  }
}

function handleDependentChange(select, dependency) {
  switch (dependency.behaviour.type) {
    case 'options':
      updateOptions(select, dependency.behaviour.getOptions())
      break
    case 'value':
      updateValue(select, dependency.behaviour.getValue())
      break
  }
}

function updateOptions(select, optionsHash) {
  if (!optionsHash) return

  // Remove all existing options except optgroups and options with the placeholder class
  for (let i = select.options.length - 1; i >= 0; i--) {
    const option = select.options[i]
    if (
      option.parentElement === select && // not inside an optgroup
      !option.classList.contains('js-c-form-select-placeholder')
    ) {
      select.remove(i)
    }
  }

  // Add new options from the hash
  Object.entries(optionsHash).forEach(([value, text]) => {
    const option = document.createElement('option')
    option.value = value
    option.text = text
    select.add(option)
  })

  // Reset to the first option so the select doesn't silently inherit a
  // stale value or rely on implicit browser default-selection behaviour.
  select.value = select.options[0]?.value ?? ''
}

function updateValue(select, value) {
  const option = Array.from(select.options).find(opt => opt.value === String(value))
  if (option) {
    select.value = String(value)
    select.dispatchEvent(new window.Event('change', { bubbles: true, cancelable: true }))
  }
}
